import { render, staticRenderFns } from "./about-modal.vue?vue&type=template&id=890141d4"
import script from "./about-modal.vue?vue&type=script&lang=js"
export * from "./about-modal.vue?vue&type=script&lang=js"
import style0 from "./about-modal.vue?vue&type=style&index=0&id=890141d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports